import styles from "./CadastroEs.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard, faEye, faEyeSlash, faFileSignature, faPhoneFlip, faUpRightFromSquare, faUser,  /* faSpinner */ } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import logo from "../../../assets/logo-horiz-movimento.gif";
import { Input } from "../../../components/Input/Input";
import Checkbox from "../../../components/Checkbox/Checkbox";
import Select from "../../../components/Select/Select";
import { validaData } from "../../../components/validacoes";
import Swal from "sweetalert2";
import { /*swalTheme,*/ Toast } from "../../../services/Swal";
import {  OutlineBtn } from "../../../components/ButtonTypes/Button";
import {
  AlignCenter,
  AlignRight,
  InputArea,
  InputAreaDupla,
} from "../../../components/Box/Box";
import useMultiStepForm from "../../../hooks/useMultiStepForm";

// import Widget from "../../../components/Widget/Widget"
import TRADUCAO from "../../../assets/traducao.json"
import useStepWizard from "../../../hooks/useStepWizzard";

const DEBUG = false;

export default function CadastroEsEducador() {
  const [termos, setTermos] = useState([{}]);
  // const [idade, setIdade] = useState();
  const [loading, setLoading] = useState(false);
  const [toggleSenha, setToggleSenha] = useState(false);
  const [form, setForm] = useState({});
  const [idioma, setIdioma] = useState("es");
  const [paises, setPaises] = useState([]);
  const [instituicoes, setInstituicoes] = useState([]);

  const subButtonStyle = { fontSize: ".6em", padding: ".3em .5em", margin: ".1em" }

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/GetTermos/Cadastro?projeto=PageGroup`)
      .then((response) => response.json())
      .then((data) => setTermos(data.payload))
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND}/api/PageGroup/GetPaises`)
      .then((response) => response.json())
      .then((data) => setPaises(data.payload))
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND}/api/PageGroup/GetInstituicoes?Id=${form.pais}`)
      .then((response) => response.json())
      .then((data) => setInstituicoes(data.payload))
  }, [form.pais]);

  function handleToggleSenha(e) {
    e.preventDefault();
    setToggleSenha(!toggleSenha);
  };

  function checkSenha(
    password,
    ifWrong = () => {
      Toast.fire({
        icon: "error",
        title: TRADUCAO[idioma].passwordSubText,
      });
      setForm({
        ...form,
        senha: "",
      });
    }
  ) {
    if (!password) return;
    const pattern = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,64})/g;

    if (pattern.test(password)) return password;
    return ifWrong;
  }

  function validaSenha(senha, confirmaSenha) {
    if (senha !== confirmaSenha) {
      Toast.fire({
        icon: "error",
        title: TRADUCAO[idioma].invalidPasswordConfim,
      });
      setForm({
        ...form,
        //senha: "",
        confirmaSenha: "",
      });
    }
  }

  function handleDataNascimento(data) {
    if (!data) return;

    if (!validaData(data)) {
      setForm({ ...form, dataNascimento: "" });
      // setIdade(undefined)
      Toast.fire({
        icon: "error",
        title: TRADUCAO[idioma].invalidDate,
      });
      return;
    }

    let idade = validaData(data)
    // setIdade(idade)

    if (idade >= 18) setForm({ ...form, resp: null })

    if (!(idade > 14) || !(idade < 100)) {
      setForm({ ...form, dataNascimento: "" });
      // setIdade(undefined)
      Toast.fire({
        icon: "error",
        title: TRADUCAO[idioma].ageMessage,
      });
      return;
    }
  }

  async function submitForm(obj) {
    // return alert("Submit")
    setLoading(true)

    const termosEnviar = [];
    Object.keys(form?.termos).map((termo) => {
      return termosEnviar.push({
        nome: termo,
        aceite: form?.termos[termo],
      });
    });
    //replace nos termos originais.
    let body = { ...obj, /*deficiencia, */ termos: termosEnviar }
    console.warn(body);

    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };

    await fetch(`${process.env.REACT_APP_BACKEND}/api/PageGroup/CadastroES/Educador`, request)
      .then((response) => response.json())
      .then((result) => {
        // result = JSON.parse(result);
        if (result.success)
          return Swal.fire({
            title: TRADUCAO[idioma].success,
            text: TRADUCAO[idioma].registrationSuccess,
            icon: "success",
            // ...swalTheme,
          })
            .then(() => {
              //navigate("/");
              window.location.replace("https://ead-es.recode.org.br/login");
            });

        return Swal.fire({
          title: TRADUCAO[idioma].error,
          text: result.message,
          icon: "error",
          // ...swalTheme,
        });
      })
      .catch((error) => {
        console.log("error", error);
        Swal.fire({
          title: TRADUCAO[idioma].error,
          text: TRADUCAO[idioma].anErrorOccurred,
          icon: "error",
          // ...swalTheme,
        });
      }).finally(() => setLoading(false));
  }

  function validaTermos() {
    const termosObrigatorios = termos.filter((termo) => termo.obrigatorio);
    let validou = true;

    termosObrigatorios.map((termo) => !form.termos?.[termo.nome] ? (validou = false) : null);

    if (validou) {
      Swal.fire({
        title: TRADUCAO[idioma].almostFinished,
        icon: 'info',
        html: `
        <p style="text-align:left">
          ${TRADUCAO[idioma].greeting} ${form.nomeCompleto.split(' ')[0]}. 
          ${TRADUCAO[idioma].beforeCompletingRegistration} ${TRADUCAO[idioma].finishRegistration}.
          <br />
          <br />
          ${TRADUCAO[idioma].fullName}: ${form.nomeCompleto}
          <br />
          ${TRADUCAO[idioma].email}: ${form.email}
        </p>
        `,
        showCancelButton: true,
        cancelButtonText: TRADUCAO[idioma].wantToChange,
        confirmButtonText: TRADUCAO[idioma].finishRegistration,
        // ...swalTheme
      }).then((result) => {
        if (result.isConfirmed) return submitForm(form);
      })
      // submitForm(form);
    } else {
      Toast.fire({
        icon: "error",
        title: TRADUCAO[idioma].termsConsentPolicy,
      });
    }
  }

  const dadosDeAcesso = (
    <section className={styles.formArea}>
      <InputAreaDupla>
        <h1>{TRADUCAO[idioma].accessData}</h1>
        <hr className={styles.separador} />
      </InputAreaDupla>

      <InputAreaDupla>
        <Input
          className={styles.input}
          required
          label={TRADUCAO[idioma].yourEmail}
          type="email"
          placeholder="estudante@email.com"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
      </InputAreaDupla>

      <InputArea>
        <Input
          className={styles.input}
          required
          value={form.senha}
          label={TRADUCAO[idioma].password}
          type={toggleSenha ? "text" : "password"}
          onChange={(e) => setForm({ ...form, senha: e.target.value })}
          onBlur={checkSenha(form.senha)}
          subText={TRADUCAO[idioma].passwordSubText}
        />
      </InputArea>

      <InputArea>
        <Input
          className={styles.input}
          required

          value={form.confirmaSenha}
          label={TRADUCAO[idioma].confirmPassword}
          type={toggleSenha ? "text" : "password"}
          onChange={(e) => setForm({ ...form, confirmaSenha: e.target.value })}
          onBlur={() => validaSenha(form.senha, form.confirmaSenha)}
          subButton={
            <OutlineBtn
              onClick={handleToggleSenha}
              className={styles.inputBtn}
              style={subButtonStyle}
            >
              {toggleSenha ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
            </OutlineBtn>
          }
        />
      </InputArea>
    </section>
  )

  const dadosPessoais = (
    <section className={styles.formArea}>
      <InputAreaDupla>
        <h1>{TRADUCAO[idioma].personalData}</h1>
        <hr className={styles.separador} />
      </InputAreaDupla>

      <InputArea>
        <Input
          className={styles.input}
          required
          label={TRADUCAO[idioma].fullName}
          value={form.nomeCompleto}
          onChange={(e) => setForm({ ...form, nomeCompleto: e.target.value })}
        />
      </InputArea>

      <InputArea>
        <Input
          className={styles.input}
          required
          label={TRADUCAO[idioma].dateOfBirth}
          type="date"
          // subText={idade ? `Eu tenho ${idade} anos de idade.` : null}
          value={form.dataNascimento}
          onChange={(e) =>
            setForm({ ...form, dataNascimento: e.target.value })
          }
          onBlur={(e) => handleDataNascimento(e.target.value)}
        />
      </InputArea>

      <InputAreaDupla>
        <Select
          className={styles.select}
          required
          label={TRADUCAO[idioma].genderIdentification}
          optionLabel={TRADUCAO[idioma].select}
          onChange={(e) => setForm({ ...form, genero: e.target.value })}
          value={form.genero}
        >
          <option value={TRADUCAO.es.male}>{TRADUCAO[idioma].male}</option>
          <option value={TRADUCAO.es.transgenderMale}>{TRADUCAO[idioma].transgenderMale}</option>
          <option value={TRADUCAO.es.female}>{TRADUCAO[idioma].female}</option>
          <option value={TRADUCAO.es.transgenderFemale}>{TRADUCAO[idioma].transgenderFemale}</option>
          <option value={TRADUCAO.es.other}>{TRADUCAO[idioma].other}</option>
          <option value={TRADUCAO.es.preferNotToSay}>{TRADUCAO[idioma].preferNotToSay}</option>
        </Select>
      </InputAreaDupla>

      {[TRADUCAO.es.other].includes(form.genero) && (
        <InputAreaDupla>
          <Input
            required
            className={styles.input}
            label={TRADUCAO[idioma].yourGender}
            type="text"
            value={form.generoOutro}
            onChange={(e) => setForm({ ...form, generoOutro: e.target.value })}
          />
        </InputAreaDupla>
      )}

      <InputArea>
        <Select
          className={styles.select}
          required
          label={TRADUCAO[idioma].highestEducationLevel}
          optionLabel={TRADUCAO[idioma].select}
          onChange={(e) => setForm({ ...form, escolaridade: e.target.value })}
          value={form.escolaridade}
        >
          <option value={TRADUCAO.es.primaryIncomplete}>{TRADUCAO[idioma].primaryIncomplete}</option>
          <option value={TRADUCAO.es.primaryComplete}>{TRADUCAO[idioma].primaryComplete}</option>
          <option value={TRADUCAO.es.secondaryIncomplete}>{TRADUCAO[idioma].secondaryIncomplete}</option>
          <option value={TRADUCAO.es.secondaryComplete}>{TRADUCAO[idioma].secondaryComplete}</option>
          <option value={TRADUCAO.es.universityIncomplete}>{TRADUCAO[idioma].universityIncomplete}</option>
          <option value={TRADUCAO.es.universityOrMore}>{TRADUCAO[idioma].universityOrMore}</option>
        </Select>
      </InputArea>

      <InputArea>
        <Select
          className={styles.select}
          required
          label={TRADUCAO[idioma].teachingExperience}
          optionLabel={TRADUCAO[idioma].select}
          onChange={(e) => setForm({ ...form, temExperiencia: e.target.value })}
          value={form.temExperiencia}
        >
          <option value={TRADUCAO.es.yes}>{TRADUCAO[idioma].yes}</option>
          <option value={TRADUCAO.es.no}>{TRADUCAO[idioma].no}</option>
        </Select>
      </InputArea>
    </section>
  )

  const dadosDeContato = (
    <section className={styles.formArea}>
      <InputAreaDupla>
        <h1>{TRADUCAO[idioma].locationData}</h1>
        <hr className={styles.separador} />
      </InputAreaDupla>

      <InputArea>
        <Input
          className={styles.input}
          label={TRADUCAO[idioma].mobilePhone}
          type="tel"
          // mask="(99) 99999-9999"
          // placeholder="(00) 99999-9999"
          mask="999999999999"
          value={form.telefone}
          onChange={(e) => setForm({ ...form, telefone: e.target.value })}
        />
      </InputArea>

      <InputArea>
        <Select
          className={styles.select}
          required
          label={TRADUCAO[idioma].hasWhatsapp}
          optionLabel={TRADUCAO[idioma].select}
          onChange={(e) => setForm({ ...form, whatsapp: e.target.value })}
          value={form.whatsapp}
        >
          <option value={TRADUCAO.es.yes}>{TRADUCAO[idioma].yes}</option>
          <option value={TRADUCAO.es.no}>{TRADUCAO[idioma].no}</option>
          {/* <option value={TRADUCAO.es.preferNotToSay}>{TRADUCAO[idioma].preferNotToSay}</option> */}
        </Select>
      </InputArea>

      <InputArea>
        <Select
          className={styles.select}
          required
          label={TRADUCAO[idioma].selectCountry}
          optionLabel={TRADUCAO[idioma].select}
          onChange={(e) => setForm({ ...form, pais: e.target.value })}
          value={form.pais}
        >
          {paises.map(pais => <option key={pais.id} value={pais.id}>{pais.nome}</option>)}
        </Select>
      </InputArea>

      <InputArea>
        <Input
          required
          className={styles.input}
          label={TRADUCAO[idioma].region}
          value={form.regiao}
          onChange={(e) => setForm({ ...form, regiao: e.target.value })}
        />
      </InputArea>

      <InputArea>
        <Input
          required
          className={styles.input}
          label={TRADUCAO[idioma].city}
          value={form.cidade}
          onChange={(e) => setForm({ ...form, cidade: e.target.value })}
        />
      </InputArea>

      {/* <InputArea>
        <Input
          required
          className={styles.input}
          label={TRADUCAO[idioma].neighborhood}
          value={form.bairro}
          onChange={(e) => setForm({ ...form, bairro: e.target.value })}
        />
      </InputArea> */}

      <InputArea>
        <Select
          className={styles.select}
          required
          label={TRADUCAO[idioma].institutionNameWillWork}
          optionLabel={TRADUCAO[idioma].select}
          onChange={(e) => setForm({ ...form, instituicao: e.target.value })}
          value={form.instituicao}
          disabled={!!!instituicoes.length}
        >
          {instituicoes.map(instituicao => <option key={instituicao.id} value={instituicao.id}>{instituicao.nome}</option>)}
        </Select>
      </InputArea>


    </section>
  )

  const aceiteDeTermos = (
    <section className={styles.formArea}>
      <InputAreaDupla>
        <h1>{TRADUCAO[idioma].terms}</h1>
        <hr className={styles.separador} />
      </InputAreaDupla>

      {termos
        .sort((a, b) =>
          a.obrigatorio > b.obrigatorio
            ? 1
            : b.obrigatorio > a.obrigatorio
              ? -1
              : 0
        )
        .map((termo, index) => (
          <InputAreaDupla key={index}>
            <Checkbox
              key={termo.nome}
              className={styles.checkbox}
              checked={form?.termos?.[termo?.nome]}
              onChange={(e) => {
                setForm({
                  ...form,
                  termos: {
                    ...form.termos,
                    [termo.nome]: e.target.checked,
                  },
                });
              }}
              required
            >
              <span>
                {termo.descricao + " "}
                {termo.obrigatorio && "* "}
                {termo.link && (
                  <a
                    className={styles.checkboxA}
                    rel="noopener noreferrer"
                    href={termo.link}
                    target="_blank"
                  >
                    <FontAwesomeIcon
                      icon={faUpRightFromSquare}
                      className={styles.icon}
                    />
                  </a>
                )}
              </span>
            </Checkbox>
          </InputAreaDupla>
        ))}
    </section>
  )

  const { currentStep, totalSteps, step, isFirstStep, isLastStep, back, next } = useMultiStepForm([
    dadosDeAcesso, //1ok
    dadosPessoais, //2ok
    dadosDeContato, //3ok
    aceiteDeTermos, //generico
  ])

  const wizzard = useStepWizard([
    { nome: TRADUCAO[idioma].accessData, icone: <FontAwesomeIcon icon={faAddressCard} size="xl" /> },
    { nome: TRADUCAO[idioma].personalData, icone: <FontAwesomeIcon icon={faUser} size="xl" /> },
    { nome: TRADUCAO[idioma].dadosDeContato, icone: <FontAwesomeIcon icon={faPhoneFlip} size="xl" /> },
    { nome: TRADUCAO[idioma].terms, icone: <FontAwesomeIcon icon={faFileSignature} size="xl" /> },
  ], currentStep, "gray", "#232323", "#d3d3d3");




  return (
    <>
      {DEBUG && <button onClick={() => console.log(form)}>DEBUG</button>}
      <section>
        <img src={logo} className={styles.logo} alt="logo" />
      </section>

      {DEBUG && (
        <AlignRight>
          <Select
            onChange={(e) => setIdioma(e.target.value)}
            optionLabel={TRADUCAO[idioma].select}
          >
            {Object.keys(TRADUCAO).map(i => (
              <option value={i} key={i}>
                {TRADUCAO[i].language}
              </option>
            ))}
          </Select>
        </AlignRight>
      )}

      <form
        noValidate={DEBUG}
        onSubmit={(e) => {
          e.preventDefault();
          isLastStep ? validaTermos() : next();
        }}
      >

        {DEBUG && (
          <AlignCenter>
            {TRADUCAO[idioma].step}: {currentStep} / {totalSteps}
          </AlignCenter>
        )}

        <AlignCenter>
          {wizzard}
        </AlignCenter>

        <InputAreaDupla>
          {step}
        </InputAreaDupla>

        <AlignRight>
          <button className={styles.submit} type="button" onClick={back} disabled={isFirstStep || loading}> {TRADUCAO[idioma].back} </button>
          <button className={styles.submit} type="submit" disabled={loading}> {isLastStep ? TRADUCAO[idioma].submit : TRADUCAO[idioma].next} </button>
        </AlignRight>
      </form >
    </>
  );
}

